import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 40 }}>
    <h2 style={{
      color: "#f5c200",
      fontWeight: 800,
      fontSize: "1.1rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      marginBottom: 12,
      borderLeft: "4px solid #2a7a6f",
      paddingLeft: 14,
    }}>
      {title}
    </h2>
    <div style={{ color: "#ccc", fontSize: "0.95rem", lineHeight: 1.8 }}>
      {children}
    </div>
  </div>
);

const ValueCard = ({ icon, title, text }) => (
  <div style={{
    background: "#1a1a1a",
    border: "1px solid #2a2a2a",
    borderRadius: 8,
    padding: "20px 24px",
    flex: "1 1 220px",
  }}>
    <div style={{ fontSize: "1.8rem", marginBottom: 10 }}>{icon}</div>
    <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 6 }}>{title}</div>
    <div style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 1.6 }}>{text}</div>
  </div>
);

export default function APropos() {
  return (
    <div style={{ background: "#0d1117", minHeight: "100vh", paddingBottom: 80 }}>
      {/* Header */}
      <div style={{
        background: "#1a1a1a",
        borderBottom: "3px solid #f5c200",
        padding: "60px 24px 40px",
        textAlign: "center",
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>⚡</div>
        <h1 style={{
          color: "#f7f4ee",
          fontWeight: 900,
          fontSize: "clamp(1.6rem, 4vw, 2.5rem)",
          marginBottom: 12,
        }}>
          À propos de Starting Five
        </h1>
        <p style={{ color: "#aaa", fontSize: "0.95rem", maxWidth: 560, margin: "0 auto" }}>
          Five Spirits, One Vision, No Limit — Lomé, Togo
        </p>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "48px 24px" }}>

        <Section title="Qui sommes-nous ?">
          <p>
            <strong style={{ color: "#f7f4ee" }}>Starting Five</strong> est né de l'ambition commune
            de cinq Togolais déterminés à construire bien plus qu'un simple projet : une vision durable
            tournée vers l'avenir du Togo.
          </p>
          <p style={{ marginTop: 12 }}>
            Répartis entre l'Afrique, l'Europe et l'Amérique, nous partageons la même volonté : créer
            des services utiles capables de simplifier le quotidien des habitants du Togo et d'Afrique.
          </p>
          <p style={{ marginTop: 12 }}>
            Nos idées sont nées presque par hasard, un été où nous nous sommes retrouvés face à des
            problématiques du quotidien. Nous avons alors décidé d'y répondre à notre façon. Comme quoi,
            les plus grands projets commencent parfois avec les situations les plus simples.
          </p>
        </Section>

        <Section title="Notre mission, vision &amp; valeurs">
          <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 8 }}>
            <ValueCard
              icon="🎯"
              title="Notre mission"
              text="Offrir des services de qualité adaptés à chaque besoin, accessibles à tous les Togolais."
            />
            <ValueCard
              icon="🌍"
              title="Notre vision"
              text="Être la référence dans notre domaine à l'échelle nationale, en construisant une marque de confiance."
            />
            <ValueCard
              icon="❤️"
              title="Nos valeurs"
              text="Simplicité, excellence, accessibilité et engagement. Nous mettons l'humain au cœur de chaque décision."
            />
          </div>
        </Section>

        <Section title="Notre histoire">
          <p>
            Starting Five a été fondé en 2025 par cinq associés partageant une vision commune du service
            et de l'innovation en Afrique de l'Ouest. Le groupe s'est d'abord constitué autour d'une
            observation simple : beaucoup de services du quotidien pouvaient être améliorés, modernisés,
            et rendus plus accessibles.
          </p>
          <p style={{ marginTop: 12 }}>
            En 2026, Starting Five lance officiellement ses premières offres, avec l'ambition de grandir
            progressivement et d'étendre ses services à d'autres villes du Togo et d'Afrique.
          </p>
        </Section>

        <Section title="Nos services">
          <p>
            Le groupe Starting Five développe plusieurs marques et services complémentaires, dont les
            détails seront progressivement dévoilés. Chaque projet est pensé pour répondre à un besoin
            concret de la vie quotidienne.
          </p>
          <p style={{ marginTop: 12 }}>
            Suivez nos actualités pour découvrir en avant-première chaque lancement.
          </p>
          <div style={{ marginTop: 20 }}>
            <Link
              to="/nos-services"
              style={{
                display: "inline-block",
                background: "transparent",
                border: "2px solid #f5c200",
                color: "#f5c200",
                padding: "10px 24px",
                borderRadius: 8,
                fontWeight: 700,
                fontSize: "0.9rem",
                textDecoration: "none",
              }}
            >
              Voir nos services →
            </Link>
          </div>
        </Section>

        <Section title="Nous contacter">
          <p>Vous souhaitez en savoir plus sur Starting Five ? Nous sommes disponibles :</p>
          <div style={{
            marginTop: 16,
            background: "#1a1a1a",
            border: "1px solid #2a2a2a",
            borderRadius: 8,
            padding: "20px 24px",
            display: "inline-block",
          }}>
            <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 8 }}>Starting Five</div>
            <div style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 2 }}>
              📧 contact@startingfive.tg<br />
              📞 +228 90 47 87 25<br />
              📍 Cité Mokpokpo, Adidogomé Lomé, Togo
            </div>
          </div>
        </Section>

        {/* Retour */}
        <div style={{ marginTop: 48, textAlign: "center" }}>
          <Link to="/" style={{
            color: "#2a7a6f",
            textDecoration: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
          }}>
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
